import { useEffect, useRef, useState } from "react";
import axios from "../api/axios";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { io } from "socket.io-client";
import Leaderboard from "./Leaderboard";
import "../css/quiz-related.css";
import { CircularProgress } from "@mui/material";
import userStore from "../../../zustand/userStore";
import { apiKeyHeader } from "../../../configs/ApiKeys";
// import { FaUserCircle } from "react-icons/fa";
// import { FaCircleUser } from "react-icons/fa6";
// import { BiCrown } from "react-icons/bi";

export default function StartQuiz() {
  const userData = userStore((state) => state.user);
  const location = useLocation();
  const state = location.state;
  const { quizType, quiz_id } = state || {};
  const [questions, setQuestions] = useState([]);
  const [current, setCurrent] = useState(0);
  const [selected, setSelected] = useState("");
  const [startTime, setStartTime] = useState(null);
  const [countdown, setCountdown] = useState(30);
  const [questionDuration, setQuestionDuration] = useState(30);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [leaderboard, setLeaderboard] = useState([]);
  const [showAnswer, setShowAnswer] = useState(false);
  const [isCorrect, setIsCorrect] = useState(null);
  const [loader, setLoader] = useState(false);
  const [showCompletion, setShowCompletion] = useState(false);
  console.log("nif", state);
  const hasSubmittedRef = useRef(false);
  const timerRef = useRef(null);
  const socketRef = useRef(null);
  const isMountedRef = useRef(true);

  //   const location = useLocation();
  //   const { state } = location;
  //   const { quizType } = state;
  const navigate = useNavigate();
  //   const { quiz_id } = useParams();

  useEffect(() => {
    isMountedRef.current = true;
    window.addEventListener("beforeunload", preventReload);
    window.addEventListener("keydown", blockReloadKeys);
    window.addEventListener("contextmenu", preventContextMenu);

    return () => {
      isMountedRef.current = false;
      clearInterval(timerRef.current);
      window.removeEventListener("beforeunload", preventReload);
      window.removeEventListener("keydown", blockReloadKeys);
      window.removeEventListener("contextmenu", preventContextMenu);
      // socketRef.current?.disconnect(); // Disconnect socket on unmount
    };
  }, []);

  const preventReload = (e) => {
    e.preventDefault();
    e.returnValue =
      "Are you sure you want to leave? Your progress will be lost.";
  };

  const blockReloadKeys = (e) => {
    const isReloadKey =
      e.key === "F5" ||
      ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === "r");
    if (isReloadKey) {
      e.preventDefault();
      e.stopPropagation();
      alert("❌ Reload is disabled during the quiz!");
    }
  };

  const preventContextMenu = (e) => {
    e.preventDefault();
  };

  useEffect(() => {
    if (state?.quiz_id && state?.quizType) {
      fetchQuestions();
    }
  }, []);

  const fetchQuestions = async () => {
    try {
      setLoader(true);
      const res = await axios.get(
        // `/participant/get-questions?quiz_id=${quiz_id}`
        // `https://web1024.docmaster.in:5010/school/get-questions?quiz_id=${quiz_id}&quiz_type=${quizType}`,
        `https://web1024.docmaster.in:5010/school/get-questions?quiz_id=${quiz_id}`,
        {
          headers: apiKeyHeader(),
        }
      );
      const duration = res.data.duration_per_question || 30;
      setQuestionDuration(duration);
      setQuestions(res.data.questions);
      setLoader(false);

      const saved = sessionStorage.getItem(`quiz_${quiz_id}_progress`);
      if (saved) {
        const parsed = JSON.parse(saved);
        setCurrent(parsed.current || 0);
        setSelected(parsed.selected || "");
        setCountdown(parsed.countdown || duration);
        setStartTime(parsed.startTime || Date.now());
      } else {
        setCountdown(duration);
        setStartTime(Date.now());
      }
    } catch (err) {
      alert("Error loading quiz questions.");
    }
  };

  // Real-time leaderboard with Socket.IO
  useEffect(() => {
    if (!quiz_id) return;

    // socketRef.current = io("https://web1024.docmaster.in:5007"); // 🔁 Replace with your backend URL
    socketRef.current = io("https://web1024.docmaster.in:5010", {
      extraHeaders: {
        ...apiKeyHeader(),
      },
    }); // 🔁 Replace with your backend URL
    // socketRef.current = io("http://192.168.0.230:5007"); // 🔁 Replace with your backend URL
    socketRef.current.emit("joinQuiz", quiz_id); // Join quiz room

    socketRef.current.on("leaderboardUpdated", (data) => {
      console.log("data", data);
      setLeaderboard(data);
    });

    return () => {
      socketRef.current?.disconnect();
    };
  }, [quiz_id]);

  useEffect(() => {
    sessionStorage.setItem(
      `quiz_${quiz_id}_progress`,
      JSON.stringify({
        current,
        selected,
        countdown,
        startTime,
      })
    );
  }, [current, selected, countdown, startTime]);

  useEffect(() => {
    if (!questions.length) return;

    setCountdown(questionDuration);
    setStartTime(Date.now());
    clearInterval(timerRef.current);

    timerRef.current = setInterval(() => {
      setCountdown((prev) => {
        if (!isMountedRef.current) return prev;

        if (prev <= 1) {
          clearInterval(timerRef.current);
          submitAnswer(true);
          return 0;
        }

        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timerRef.current);
  }, [current, questionDuration, questions.length]);

  const handleOptionSelect = (label) => {
    setSelected(label);
  };

  const submitAnswer = async (auto = false) => {
    if (hasSubmittedRef.current || isSubmitting) return;

    hasSubmittedRef.current = true;
    setIsSubmitting(true);

    const q = questions[current];
    if (!q) return;

    const timeTaken = Date.now() - startTime;
    // const timeTaken_1 = Date.now() - countdown;
    console.log("Submitting Answer:", {
      question_id: q.id,
      user_id: userData?.id,
      selected_option: selected, // Log the raw state value
      time_taken_ms: selected ? timeTaken : questionDuration * 1000,
      quiz_id,
    });

    const isCorrectAnswer = selected === q.correct_option;
    setIsCorrect(isCorrectAnswer);
    setShowAnswer(true);
    try {
      // await axios.post("/participant/submit-answer", {
      await axios.post(
        "https://web1024.docmaster.in:5010/school/submit-answer",
        {
          question_id: q.id,
          user_id: userData?.id,
          selected_option: selected || null,
          time_taken_ms: selected ? timeTaken : questionDuration * 1000,
          quiz_id,
        },
        {
          headers: apiKeyHeader(),
        }
      );

      // 🔁 Ask backend to update leaderboard
      socketRef.current?.emit("requestLeaderboardUpdate", quiz_id);
    } catch (err) {
      console.error("Answer submission failed:", err);
    }

    if (current + 1 < questions.length) {
      setTimeout(() => {
        setCurrent((prev) => prev + 1);
        setSelected(""); // reset here ✅
        setIsSubmitting(false);
        setShowAnswer(false);
        setIsCorrect(null);
        hasSubmittedRef.current = false;
      }, 2000);
    } else {
      await axios.post(
        // `/participant/complete-quiz?user_id=${userData.id}&quiz_id=${quiz_id}`
        `https://web1024.docmaster.in:5010/school/complete-quiz?user_id=${userData.id}&quiz_id=${quiz_id}`,
        {},
        {
          headers: apiKeyHeader(),
        }
      );
      // , { quiz_id });
      sessionStorage.removeItem(`quiz_${quiz_id}_progress`);
      setShowCompletion(true);
      setTimeout(() => {
        setShowCompletion(false);
        navigate("/quiz-new/dashboard");
      }, 4000);
      // window.location.reload();
    }
  };

  if (!questions.length) {
    return (
      <p
        style={{
          textAlign: "center",
          paddingTop: "60px",
          fontSize: "50px",
          color: "black",
        }}
      >
        No questions found
      </p>

      // <div className="loading text-center">
      //   <div className="spinner mb-10"></div>
      //   <p>Loading questions...</p>
      // </div>
    );
  }
  // if (questions.length === 0) {
  //   return <p>No questions found</p>;
  // }

  const q = questions[current];
  const progress = ((current + 1) / questions.length) * 100;

  return (
    <div className="w-100">
      {state?.quizType && state?.quiz_id && (
        <div className="w-100">
          {loader && <CircularProgress />}
          {/* Left: Quiz Content */}
          {/* <div className="w-2/3"> */}
          {/* <div style={{ width: "90%" }}> */}
          {/* <div style={{ width: "40%" }}> */}
          <div className="row w-100 mt-3">
            <div className="col-md-9">
              <div
                className="w-100 "
                style={{
                  // backgroundImage: "url(/images/1.png)",
                  borderRadius: "20px",
                  color: "#fff",
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "100%",
                  // padding: "4% 4% 0px 10%",
                  // height: "100vh",
                  // minHeight: "80vh",
                }}
              >
                <div
                  className="card p-4 striped-border rounded"
                  style={{
                    backgroundColor: "transparent",
                    padding: "0",
                    width: "100%",
                    boxShadow: "none",
                    position: "relative", // ✅ Added
                    minHeight: "70vh", // ✅ Ensures proper space
                  }}
                >
                  {/* <img
            src="/images/qm.png"
            style={{
              width: "75px",
              height: "75px",
              position: "absolute",
              left: "-45px",
              top: "-45px",
            }}
          /> */}
                  <div className="panel">
                    <div className="progress mb-2">
                      <div
                        className="progress-bar"
                        style={{
                          width: `${progress}%`,
                          backgroundColor: "#4caf50",
                          height: "10px",
                        }}
                      ></div>
                    </div>
                    <div
                      className="mb-3"
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <h3 className="mb-0 text-20 font-semibold">
                        Question {current + 1}
                      </h3>
                      <p
                        className={`font-medium ${
                          countdown <= 5
                            ? "text-red-600 border border-red-600 p-2 rounded"
                            : ""
                        }`}
                      >
                        ⏳ Time left: <b>{countdown}s</b>
                      </p>
                    </div>
                    <div>
                      <p
                        className="mb-3  text-black"
                        style={{ color: "#000", fontSize: "18px" }}
                      >
                        {q.content}
                      </p>
                    </div>
                    <div className="grid grid-cols-2 gap-2 mb-4">
                      {q.options.map((opt) => {
                        const isSelected = selected === opt.label;
                        const isCorrectOption = opt.label === q.correct_option;

                        let style = {
                          padding: "10px 16px",
                          border: "1px solid #ccc",
                          borderRadius: "8px",
                          cursor: "pointer",
                          fontWeight: "500",
                          transition: "all 0.3s ease",
                        };

                        if (showAnswer) {
                          if (isCorrectOption) {
                            style.backgroundColor = "#4CAF50"; // green
                            style.color = "white";
                          } else if (isSelected && !isCorrectOption) {
                            style.backgroundColor = "#F44336"; // red
                            style.color = "white";
                          } else {
                            style.backgroundColor = "#f0f0f0";
                            style.color = "black";
                          }
                          style.hover = {
                            backgroundColor: "rgb(173 229 175)",
                          };
                        } else {
                          if (isSelected) {
                            style.backgroundColor = "#1976D2"; // blue for selected
                            style.color = "white";
                          } else {
                            style.backgroundColor = "#f0f0f0";
                            style.color = "black";
                          }
                          style.hover = {
                            backgroundColor: "rgb(173 229 175)",
                          };
                        }

                        return (
                          <button
                            className="text-left btn-option"
                            key={opt.label}
                            style={style}
                            disabled={showAnswer}
                            onClick={() => handleOptionSelect(opt.label)}
                          >
                            {opt.label}: {opt.content}
                          </button>
                        );
                      })}
                    </div>
                  </div>
                  <div
                    className="text-right bg-white w-100"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      background: "#fff",
                      borderTop: "1px solid #ddd",
                      padding: "10px 15px",
                      position: "sticky",
                      bottom: "0",
                      zIndex: "10",
                    }}
                  >
                    {showAnswer ? (
                      <p
                        className={`mb-0 font-semibold ${
                          isCorrect ? "text-green-600" : "text-red-600"
                        }`}
                      >
                        &nbsp;
                        {isCorrect
                          ? "✅ Correct!"
                          : `❌ Incorrect! Correct answer: ${q.correct_option}`}
                      </p>
                    ) : (
                      <p>&nbsp;</p>
                    )}
                    <button
                      className="btn btn-success"
                      onClick={() => submitAnswer()}
                      style={{ top: "1%" }}
                      disabled={!selected || isSubmitting || showAnswer}
                    >
                      Submit
                      {/* {current + 1 < questions.length ? "Next" : "Submit"} */}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-3">
              {/* Right: Leaderboard */}
              {quizType === 1 && (
                <Leaderboard leaderboard={leaderboard} questions={questions} />
              )}{" "}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    minHeight: "90vh",
    backgroundColor: "rgba(0, 0, 0, 0.7)",
    zIndex: 9999,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    animation: "fadeIn 0.4s ease",
  },
  popup: {
    backgroundColor: "#fff",
    padding: "40px 60px",
    borderRadius: "12px",
    textAlign: "center",
    boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
    animation: "zoomIn 0.4s ease",
  },
  emoji: {
    fontSize: "30px",
    marginBottom: "16px",
    fontWeight: "bold",
  },
  title: {
    fontSize: "24px",
    fontWeight: "bold",
    color: "#2e7d32",
    marginBottom: "10px",
  },
  subtitle: {
    fontSize: "16px",
    color: "#333",
  },
};
